import { HStack, Button, Text } from "@chakra-ui/react";
import { useState, useRef } from "react";
import { handleYtdToggle } from "../../utils";

const YtdToggleCompact = ({ labelLeft = "Monthly", labelRight = "Year-To-Date"}) => {
  const [isYtd, setIsYtd] = useState(() => {
    try {
      return sessionStorage.getItem("ytd") === "true";
    } catch {
      return false;
    }
  });

  const [isDisabled, setIsDisabled] = useState(false);
  const timeoutRef = useRef(null);

  const handleToggle = (next) => {
    if (isDisabled) return;
    setIsDisabled(true);

    setIsYtd(next);
    handleYtdToggle(next);

    try {
      sessionStorage.setItem("ytd", JSON.stringify(next));
    } catch {}

    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setIsDisabled(false), 500);
  };

  return (
    <HStack
      size="sm"
      width="100%"
      minW={"300px"}
      height={{ base: "auto", md: "42px" }}
      borderRadius="8px"
      overflow="hidden"
      bgColor="#E6E9EC"
      p="6px"
      spacing={1}
      flexDirection={{ base: "column", md: "row" }}
    >
      <Button
        onClick={() => handleToggle(false)}
        bg={!isYtd ? "white" : "#E6E9EC"}
        color="#262A2C"
        _hover={{ bg: !isYtd ? "white" : "#E6E9EC" }}
        flex="1"
        height="30px"
        borderRadius="8px"
        fontSize={ "14px" }
        width={{ base: "100%", md: "auto" }}
        minH="30px"
        isDisabled={isDisabled}
        fontWeight={600}
      >
        <Text>{labelLeft}</Text>
      </Button>

      <Button
        onClick={() => handleToggle(true)}
        bg={isYtd ? "white" : "#E6E9EC"}
        color="#262A2C"
        _hover={{ bg: isYtd ? "white" : "#E6E9EC" }}
        flex="1"
        height="30px"
        borderRadius="8px"
        fontSize={ "14px" }
        width={{ base: "100%", md: "auto" }}
        minH="30px"
        fontWeight={600}
        isDisabled={isDisabled}
      >
        <Text>{labelRight}</Text>
      </Button>
    </HStack>
  );
};

export default YtdToggleCompact;